<template>
  <div
    class="asc-related-mx-recs-wrapper--container"
    :class="{ noRelatedMxRecs: !values.length }"
  >
    <div v-if="isExpanded" class="grid--container">
      <asc-related-mx-recs-grid
        class="grid"
        :values="values"
        :on-open="onOpen"
        :grid-columns="gridColumns"
        :grid-filters="gridFilters"
        :aircraft-details="aircraftDetails"
      />
      <div
        v-if="!values.length"
        class="asc-related-mx-recs-wrapper--container-label"
      >
        <asc-label
          class="asc-related-mx-recs-wrapper--container-label-text"
          size="sm"
          :value="labelText"
        />
      </div>
    </div>

    <div v-else class="condensed-grid">
      <div v-if="values.length" class="related-alerts">
        <div
          v-for="(row, index) in values"
          :key="index"
          class="related-alerts--row"
        >
          <a :href="row.issueId" class="issueId">{{ row.issueId }}</a>
          <div class="description">{{ row.analyticModuleName }}</div>
          <div class="time">
            Last Updated: {{ getFormatedUTCDateTime(row.lastAlertDate) }}
          </div>
        </div>
      </div>
      <p v-else class="noData">{{ labelText }}</p>
    </div>
  </div>
</template>

<script>
import { AscGridPropsMixin, AscMxRecPermissionMixin } from '@/components/mixins'
import AscRelatedMxRecsGrid from '@/components/molecules/AscRelatedMxRecsGrid'
import AscLabel from '@/components/atoms/AscLabel'
import { getNewFormatUTCDateTime } from '@/utilities/dates'

export default {
  name: 'AscRelatedMxRecsWrapper',

  components: {
    AscRelatedMxRecsGrid,
    AscLabel,
  },

  mixins: [AscGridPropsMixin, AscMxRecPermissionMixin],

  props: {
    values: {
      type: Array,
      default: () => [],
    },
    onOpen: {
      type: Function,
      default: () => {},
    },
    aircraftDetails: {
      type: Object,
      default: () => {},
    },
    isRecommendationTab: {
      type: Boolean,
      default: false,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    labelText() {
      const text =
        this.isMxRecEditPermission || this.isRecommendationTab
          ? `There are no related issues`
          : `There are no related alerts or Mx Recs`

      return this.aircraftDetails?.tail?.name
        ? text + ` for ${this.aircraftDetails.tail.name}`
        : text
    },
  },

  methods: {
    getFormatedUTCDateTime(dateTime) {
      return getNewFormatUTCDateTime(dateTime, true)
    },
  },
}
</script>

<style lang="scss">
.asc-related-mx-recs-wrapper--container {
  .grid--container {
    margin-top: 16px;
  }

  &.noRelatedMxRecs {
    .asc-related-mx-recs-grid {
      height: 75px;
    }
  }

  &-label {
    position: relative;
    background-color: $gray-0;
    padding: 10px;
  }

  .condensed-grid {
    .related-alerts--row {
      margin-bottom: 16px;

      .issueId {
        color: $accent-600;
        margin-bottom: 4px;
      }
      .description {
        margin-bottom: 4px;
      }
      .time {
        color: $gray-600;
      }
    }

    .noData {
      color: $gray-600;
    }
  }
}
</style>
